<template lang="pug">
  section
    WtTitle steps / reminders
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "MemberStepsReminders",

  components: { WtTitle }
};
</script>

<style lang="sass" scoped></style>
